import { useState } from "react";
import { Reveal } from "../Reveal";

export const FAQ = ({ t }) => {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32"
      style={{ background: "var(--paper)" }}
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="mb-14 md:mb-16">
          <Reveal>
            <span className="eyebrow mb-8">{t.faq.label}</span>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="display-xl text-[30px] md:text-[42px] lg:text-[48px] mt-6">
              {t.faq.title}
            </h2>
          </Reveal>
        </div>

        <div
          className="divide-y"
          style={{ borderTop: "1px solid var(--border)", borderColor: "var(--border)" }}
        >
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={i * 90}>
                <article
                  data-testid={`faq-item-${i}`}
                  data-open={isOpen}
                  style={{ borderBottom: "1px solid var(--border)" }}
                >
                  <button
                    type="button"
                    data-testid={`faq-q-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-a-${i}`}
                    className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left"
                    style={{ color: "var(--heading)" }}
                  >
                    <h3
                      className="font-serif text-xl md:text-2xl leading-snug"
                      style={{ color: "var(--heading)" }}
                    >
                      {item.q}
                    </h3>
                    <span
                      aria-hidden="true"
                      style={{
                        flex: "none",
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        background: isOpen ? "var(--gold-500)" : "transparent",
                        border: "1px solid var(--gold-500)",
                        color: isOpen ? "var(--green-800)" : "var(--gold-500)",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 18,
                        lineHeight: 1,
                        transition: "background var(--dur) var(--ease), color var(--dur) var(--ease)",
                      }}
                    >
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>
                  <div
                    id={`faq-a-${i}`}
                    data-testid={`faq-a-${i}`}
                    role="region"
                    aria-hidden={!isOpen}
                    style={{
                      display: "grid",
                      gridTemplateRows: isOpen ? "1fr" : "0fr",
                      opacity: isOpen ? 1 : 0,
                      transition:
                        "grid-template-rows 400ms var(--ease), opacity 350ms var(--ease)",
                    }}
                  >
                    <div style={{ overflow: "hidden", minHeight: 0 }}>
                      <p
                        className="text-[15px] md:text-[16px] leading-relaxed pb-6 md:pb-8 pr-12"
                        style={{ color: "var(--fg-muted)" }}
                      >
                        {item.a}
                      </p>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
